/** @format */
import React, { FC, useState, useEffect, createContext } from 'react'
import styled from 'styled-components'
import MonitorCloudCrumb from './MonitorCloudCrumb'
import CloudListTable from 'src/containers/MonitorCloud/CloudListTable/CloudListTable'
import DrawerContainer from 'src/containers/MonitorCloud/CloudListTable/DrawerContainer'
import DiabolBatchExport from 'src/containers/MonitorCloud/CloudListTable/DiabolBatchExport'
import IbTopology from 'src/containers/MonitorCloud/IbTopology'
import RoceTopology from 'src/containers/MonitorCloud/RoceTopology'
import {
  initDrawerObject,
  DrawerObject,
  handleCustomInstance,
  InstanceObject,
  DrawerType,
  ChildType,
  IContextType,
  childTypeMap
} from './constants'
import { request } from 'src/utils'
import { useParams, useHistory } from 'react-router'
import { useAsync } from 'react-use'
import API from 'src/api/ApiCloud'
import useGlobalData from 'src/hooks/useGlobalData'
import { _$, Tabs, Tab } from 'kpc-react'

interface IParamsType {
  name: string
}

export const CountContext = createContext<IContextType>({})

const localTopTypes = [39, 97, 99, 109]

const MonitorList: FC<Record<string, never>> = ({ className }) => {
  const { name } = useParams<IParamsType>()
  const history = useHistory()
  const productMenu = useGlobalData('productMenu')
  const [curProduct, setCurProduct] = useState<any>()
  const [contextState, setContextState] = useState<IContextType>({})
  const [drawerObject, setDrawerObject] = useState<DrawerObject>(initDrawerObject) // 抽屉相关state
  const [checkedData, setCheckedData] = useState<any[]>([])
  const [batchExportVisible, setBatchExportVisible] = useState<boolean>(false)
  // list/rdma切换
  const [tabValue, setTabValue] = useState<'list' | 'ib' | 'roce'>('list')

  // 获取数据源
  const { value: ib_source } = useAsync(async () => {
    if (curProduct?.productType === 43) {
      const ib_result = await request(API.getUFMClusters, {})
      return ib_result?.data?.ListClusterResult || []
    }
  }, [curProduct])
  // 获取数据源
  const { value: roce_source } = useAsync(async () => {
    if (curProduct?.productType === 43) {
      const roce_result = await request(API.getNCEClusters, {})
      return roce_result?.data?.ListClusterResult || []
    }
  }, [curProduct])

  useEffect(() => {
    if (name && productMenu?.length) {
      const findType = productMenu.find(({ link }) => link.split('/')[3] === name)
      setTabValue('list')
      if (findType !== undefined) {
        setCurProduct(findType)
        const { childType, subMenus, productType } = findType
        // 有topType的产品类型
        if (childType !== productType) {
          getChildTypes(childType)
          return
        }
        // Redis、Cassandra
        if (localTopTypes.includes(childType)) {
          getChildTypes(childType)
          return
        }
        // mongoDB
        if (subMenus?.length) {
          const { childType } = subMenus[0]
          getChildTypes(childType, subMenus)
          return
        }
        setContextState({
          productType: String(findType.productType)
        })
      } else {
        history.push('/monitor/generalview/home')
      }
    }
  }, [name, productMenu])

  // 获取childTypes
  const getChildTypes = async (topType, tabsList?) => {
    const { productType } = productMenu.find(({ link }) => link.split('/')[3] === name)
    if (productType !== undefined) {
      if (childTypeMap[topType]) {
        const data = childTypeMap[topType]
        const { childType, childName } = data[0]
        setContextState({
          productType,
          tabsList,
          setTabsValue,
          topType,
          childTypes: data,
          childTypeValue: { childType, childName },
          setChildTypeValue: setChildTypeValue
        })
      } else {
        const { data } = await request(API.getChildType, {
          data: {
            TopType: topType
          }
        })
        if (data?.childTypeList?.length) {
          const { childType, childName } = data?.childTypeList[0]
          setContextState({
            productType,
            tabsList,
            setTabsValue,
            topType,
            childTypes: data?.childTypeList,
            childTypeValue: { childType, childName },
            setChildTypeValue: setChildTypeValue
          })
        }
      }
    }
  }

  // 设置context
  const setChildTypeValue = (childType: ChildType) => {
    setContextState({
      ...contextState,
      childTypeValue: childType
    })
  }

  // 切换tabs
  const setTabsValue = (productType, value) => {
    setContextState({})
    const find = productMenu.find(menu => parseInt(productType) === menu.productType)
    const { subMenus } = find
    getChildTypes(value, subMenus)
  }

  // 打开详情抽屉
  const openDrawer = (instance: InstanceObject, type: DrawerType) => {
    setDrawerObject({
      drawerType: type,
      visible: true,
      drawerInstance: instance
    })
  }

  // 关闭详情抽屉
  const closeDrawer = () => {
    setDrawerObject(initDrawerObject)
  }

  // 打开【批量导出】弹窗
  const openBatchExport = () => {
    setBatchExportVisible(true)
  }

  // 关闭弹窗
  const closeDialog = (_c, value) => {
    if (!value) {
      setBatchExportVisible(value)
    }
  }

  return (
    <div className={className}>
      <CountContext.Provider value={contextState}>
        {/* 面包屑 */}
        {curProduct ? (
          <MonitorCloudCrumb pageType="list" productType={curProduct.productType} />
        ) : null}
        {ib_source?.length || roce_source?.length ? (
          <Tabs
            type="card"
            value={tabValue}
            on$change-value={(_c, value) => {
              setTabValue(value)
            }}
          >
            <Tab value="list">资源列表</Tab>
            {ib_source?.length ? <Tab value="ib">IB网络拓扑</Tab> : null}
            {roce_source?.length ? <Tab value="roce">ROCE网络拓扑</Tab> : null}
          </Tabs>
        ) : null}
        {/* table */}
        <div className="monitor_list">
          {tabValue === 'list' ? (
            <CloudListTable
              // region={region}
              openDrawer={openDrawer}
              showCustomInstance={handleCustomInstance(curProduct?.productType)}
              openBatchExport={openBatchExport}
              checkedData={checkedData}
              setCheckedData={setCheckedData}
            />
          ) : null}
          {tabValue === 'ib' ? <IbTopology sourceList={ib_source || []} /> : null}
          {tabValue === 'roce' ? <RoceTopology sourceList={roce_source || []} /> : null}
        </div>

        <DrawerContainer
          type={drawerObject.drawerType}
          productType={curProduct?.productType}
          instanceName={drawerObject.drawerInstance?.instanceName}
          instanceId={drawerObject.drawerInstance?.instanceId}
          visible={drawerObject.visible}
          closeDrawer={closeDrawer}
        />

        {/* 批量导出，暂时取消 */}
        {false ? (
          <DiabolBatchExport
            visible={batchExportVisible}
            handleChange={closeDialog}
            checkedData={checkedData}
          />
        ) : null}
      </CountContext.Provider>
    </div>
  )
}

export default styled(MonitorList)`
  .k-tabs {
    border-bottom: none;
    .k-active-bar {
      border-left: none;
      border-right: none;
    }
  }
`
